import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ConfigurationApi } from '../interfaces/configuration.interface';

@Injectable({
    providedIn: 'root'
})
export class AppDataService {

    private _configurations: any = {};
    private _confidentialities: any = {};
    private _urgencies: any = {};
    private _importances: any = {};

    public confidentialitiesRequest$: Observable<any> | null = null;
    public urgenciesRequest$: Observable<any> | null = null;
    public importancesRequest$: Observable<any> | null = null;

    constructor(private httpClient: HttpClient) { }

    LoadConfigurations() {
        return this.httpClient.get(`${environment.spaUrl}apis/api/OpenConfigurationApi/GetConfigurations`).pipe(tap(res => {
            this._configurations = res;
            return res
        }))
    }

    public get configurations(): ConfigurationApi { return this._configurations; }
    public set configurations(value: any) { this._configurations = value; }

    public get confidentialities() { return this._confidentialities; }
    public set confidentialities(v) { this._confidentialities = v; }

    public get urgencies() { return this._urgencies; }
    public set urgencies(v) { this._urgencies = v; }

    public get importances() { return this._importances; }
    public set importances(v) { this._importances = v; }
}
